// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BottomBar__container___NlRab {
	position: fixed;
	bottom: 0;
	text-align: center;
	width: 100%;
	border-radius: 4px 4px 0px 0px;
	padding-bottom: 5px;
	padding-top: 5px;
	z-index: 20000;
	overflow: visible;
}

.BottomBar__container_ifHighPerformance___E7ZYe {
	transition: border 1.5s;
}

.BottomBar__verticalCenter___sxwh6 {
	margin: 0;
	position: absolute;
	top: 50%;
	left: 50%;
	-ms-transform: translate(-50%, -50%);
	transform: translate(-50%, -50%);
	width: 100%;
	transition: background 0.5s;
}

.BottomBar__verticalCenterBackground___JmXVd {
	padding: 4px 0px 2px 0px;
}

.BottomBar__action___jrwDG {
	padding: 5px;
}

.BottomBar__displaySmall___QeGVD {
	height: 80px;
	font-size: 24px;
}

.BottomBar__quickJournalBackground___X9qeN {
	height: 100%;
	background: transparent;
	font-size: 25px;
}

.BottomBar__controlsBackdrop___MinrH {
	position: absolute;
	left: 0;
	right: 0;
	bottom: 0;
	top: 0;
	background: transparent;
	z-index: 0;
	pointer-events: none;
}

.BottomBar__controlsContent___PKSOS {
	display: flex;
	width: 100%;
	align-items: stretch;
	position: relative;
	z-index: 1;
	transform: translateY(0);
	transition: transform 500ms ease;
	will-change: transform;
}

.BottomBar__controlsContentHidden___E_kmD {
	/* Clear raised shields and their glow without clipping the visible footer. */
	transform: translateY(calc(100% + 40px));
	pointer-events: none;
}

.BottomBar__controlsColumn___KvU7R {
	display: flex;
	flex: 1 1 0;
	min-width: 0;
	align-items: flex-end;
	min-height: 100%;
}

.BottomBar__controlsColumnLeft___Zeq4e {
	justify-content: flex-start;
}

.BottomBar__controlsColumnCenter___JgOQE {
	justify-content: center;
}

.BottomBar__controlsColumnRight___EtNB1 {
	justify-content: flex-end;
}

@keyframes BottomBar__emotionSelectorFadeIn___q2JXH {
	from {
		opacity: 0;
	}
	to {
		opacity: 1;
	}
}

.BottomBar__emotionSelectorFade___Gq4ia {
	animation: BottomBar__emotionSelectorFadeIn___q2JXH 250ms ease-out;
}

.BottomBar__ifDesktop_Transition___k3iqr {
	transition: height 0.5s, opacity 0.5s, font-size 0.2s;
}

.BottomBar__displayParticlesToggle___eyFk6 {
	margin: 0;
	padding-top: 10px;
	font-size: 15px;
	position: relative;
	top: 3px;
}

.BottomBar__minimizeBottomBar___zWL8V {
	font-size: 28px;
	margin-bottom: 2px;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `BottomBar__container___NlRab`,
	"container_ifHighPerformance": `BottomBar__container_ifHighPerformance___E7ZYe`,
	"verticalCenter": `BottomBar__verticalCenter___sxwh6`,
	"verticalCenterBackground": `BottomBar__verticalCenterBackground___JmXVd`,
	"action": `BottomBar__action___jrwDG`,
	"displaySmall": `BottomBar__displaySmall___QeGVD`,
	"quickJournalBackground": `BottomBar__quickJournalBackground___X9qeN`,
	"controlsBackdrop": `BottomBar__controlsBackdrop___MinrH`,
	"controlsContent": `BottomBar__controlsContent___PKSOS`,
	"controlsContentHidden": `BottomBar__controlsContentHidden___E_kmD`,
	"controlsColumn": `BottomBar__controlsColumn___KvU7R`,
	"controlsColumnLeft": `BottomBar__controlsColumnLeft___Zeq4e`,
	"controlsColumnCenter": `BottomBar__controlsColumnCenter___JgOQE`,
	"controlsColumnRight": `BottomBar__controlsColumnRight___EtNB1`,
	"emotionSelectorFade": `BottomBar__emotionSelectorFade___Gq4ia`,
	"emotionSelectorFadeIn": `BottomBar__emotionSelectorFadeIn___q2JXH`,
	"ifDesktop_Transition": `BottomBar__ifDesktop_Transition___k3iqr`,
	"displayParticlesToggle": `BottomBar__displayParticlesToggle___eyFk6`,
	"minimizeBottomBar": `BottomBar__minimizeBottomBar___zWL8V`
};
module.exports = ___CSS_LOADER_EXPORT___;
